import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ThemeMode } from '@fleet-beat/core';

@Component({
  selector: 'fb-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorComponent {
  @Input() control: FormControl | FormGroup;
  @Input() label: string;
  @Input() themeMode: ThemeMode;
}
